import basicAuth from "@/app/ivr/assets/basic_authentication.png?url";
import apiKeyAuth from "@/app/ivr/assets/api_key.png?url";
import tokenAuth from "@/app/ivr/assets/token_authentication.png?url";

export enum BotStatus {
  Active = 1,
  Inactive = 2,
}

export enum BotType {
  Automatic = 1,
  Survey = 2,
}

export enum TemplateTabsKey {
  BuildBot = "build_bot",
  GeneralData = "general_data",
  Schedule = "schedule",
  Identifiers = "linked_identifiers",
}

export enum NodeType {
  NumericDialing = 1,
  Option = 2,
  WrongOption = 3,
  VariableCapture = 4,
  SatisfactionRanking = 5,
  ExpiredTime = 6,
  WrongOptionApi = 7,
  OptionConsultApi = 8,
}

export enum ActionType {
  NumericDialing = 1,
  TransferToQueue = 2,
  EndCall = 3,
  BackToNode = 4,
  SendWppTemplate = 5,
  VariableCapture = 6,
  SatisfactionRanking = 7,
  ConnectorApi = 8,
}

export const TextOptionConnectorApi = 'El valor ha devolver de la API'

export type MaxAttemptsAction = ActionType.EndCall | ActionType.TransferToQueue;

export enum RequestType {
  Get = 1,
  Post = 2,
}

export const RequestTypeText = {
  [RequestType.Get]: 'GET',
  [RequestType.Post]: 'POST',
}

export const requestTypes = [
  { label: RequestTypeText[RequestType.Get],  value: RequestType.Get },
  { label: RequestTypeText[RequestType.Post], value: RequestType.Post },
]

export const DescriptionRequestType = {
  [RequestType.Get]: 'Utilizado cuando se necesita obtener datos del servidor.',
  [RequestType.Post]: 'Utilizado cuando se necesita enviar datos al servidor.'
}

export enum AuthenticationType {
  BasicAuth = 1,
  APIKey = 2,
  Token = 3,
}

export const AuthenticationTypeName = {
  [AuthenticationType.BasicAuth]: 'Autenticación básica',
  [AuthenticationType.APIKey]: 'API Key',
  [AuthenticationType.Token]: 'Token',
}

export const authenticationTypes = [
  { 
    label: AuthenticationTypeName[AuthenticationType.BasicAuth], 
    value: AuthenticationType.BasicAuth
  },
  { 
    label: AuthenticationTypeName[AuthenticationType.APIKey], 
    value: AuthenticationType.APIKey
  },
  { 
    label: AuthenticationTypeName[AuthenticationType.Token], 
    value: AuthenticationType.Token
  },
]

export const ImageAuthenticationType = {
  [AuthenticationType.BasicAuth]: basicAuth,
  [AuthenticationType.APIKey]: apiKeyAuth,
  [AuthenticationType.Token]: tokenAuth,
}

export const DescriptionAuthenticationType = {
  [AuthenticationType.BasicAuth]: 'Autenticación mediante usuario y contraseña codificados.',
  [AuthenticationType.APIKey]: 'Utiliza una clave única proporcionada por el servicio para autorizar las peticiones de la API.',
  [AuthenticationType.Token]: 'Autenticación mediante token generado con usuario y contraseña.',
}

export enum ResponseType {
  Number = 1,
  Boolean = 2,
  String = 3,
}

export const ResponseTypesText = {
  [ResponseType.Number]: 'Numérico',
  [ResponseType.Boolean]: 'Boolean',
  [ResponseType.String]: 'String',
}

export const ResponseTypesTooltip = {
  [ResponseType.Number]: 'Valor numérico que puede representar cantidades o selección de opciones en flujos.',
  [ResponseType.Boolean]: 'Valor lógico con dos posibles estados: verdadero o falso.',
  [ResponseType.String]: 'Cadena de texto que puede contener letras, números y símbolos.',
}

export const responseTypes = [
  { label: ResponseTypesText[ResponseType.Number],  value: ResponseType.Number, tooltip: ResponseTypesTooltip[ResponseType.Number] },
  { label: ResponseTypesText[ResponseType.Boolean], value: ResponseType.Boolean, tooltip: ResponseTypesTooltip[ResponseType.Boolean] },
  { label: ResponseTypesText[ResponseType.String], value: ResponseType.String, tooltip: ResponseTypesTooltip[ResponseType.String] },
]

export enum SendType {
  Body = 1,
  Params = 2,
}

export const SendTypeText = {
  [SendType.Body]: 'Body',
  [SendType.Params]: 'Params',
}

export const sendTypes = [
  { label: SendTypeText[SendType.Body], value: SendType.Body },
  { label: SendTypeText[SendType.Params], value: SendType.Params },
]

export enum ConnectionType {
  Ivr = 'IVR',
  Chatbot = 'Chatbot',
}

export const ConnectionTypeText = {
  [ConnectionType.Ivr]: 'IVR Operador automático',
  [ConnectionType.Chatbot]: 'Chatbot WhatsApp',
}

export const ConnectionTypeGroup = {
  [ConnectionType.Ivr]: 'IVR Operador automático',
  [ConnectionType.Chatbot]: 'Chatbots de WhatsApp',
}